import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GetBuyerSelectionPaidBefore } from '../slices/marketplace/pricing/get-buyer-selection-paid-before.thunk';
import { BuyerSelectionPaidBefore } from '../models/MarketplaceCommerce/BuyerSelectionPaidBefore';

// [#1309] The Buyers a selection step's fee was already paid for, loaded when a selection pop-up opens. Without them the
// pop-up prices as before; the server's price check stays the final word.
export const useBuyerSelectionPaidBefore = (engagementId: number, eventId: string, isPriced: boolean): number[] => {
    const dispatch = useDispatch() as any;
    const [paidBeforeBuyerIds, setPaidBeforeBuyerIds] = useState<number[]>([]);

    useEffect(() => {
        if (!isPriced || !engagementId || !eventId) {
            setPaidBeforeBuyerIds([]);
            return;
        }

        let isCurrent = true;
        dispatch(GetBuyerSelectionPaidBefore({ engagementId, eventId }))
            .unwrap()
            .then((result: BuyerSelectionPaidBefore) => {
                if (isCurrent) {
                    setPaidBeforeBuyerIds(result?.paidBeforeBuyerIds ?? []);
                }
            })
            .catch(() => {
                if (isCurrent) {
                    setPaidBeforeBuyerIds([]);
                }
            });

        return () => {
            isCurrent = false;
        };
    }, [dispatch, engagementId, eventId, isPriced]);

    return paidBeforeBuyerIds;
};
